import React, { useState } from 'react';
// Modal
import RestrictionFormModal from '../../../layouts/Modals/RestrictionFormModal';

const RestrictionsCreate = () => {
  const [ show, setShow ] = useState(false);
  return (
    <>
      <div className="form-group text-right">
        <button
          className="btn btn-primary btn-sm"
          type="button"
          onClick={() => setShow(true)}
        >Create</button>
      </div>
      {/* Modal */}
      {show &&
        <RestrictionFormModal
          show={show}
          onHide={() => setShow(false)}
        />
      }
    </>
  )
}

export default RestrictionsCreate;
